import { ADD_DISHES } from './types'

export const addDishes = items => ({
  type: ADD_DISHES,
  payload: { items }
})
